import { useAppDispatch, useAppSelector } from '../store/hooks'
import { setOffset, fetchApps } from '../store/appsSlice'
import AppCard from './AppCard'
import './AppCardGrid.css'

function AppCardGrid() {
  const dispatch = useAppDispatch()
  const items = useAppSelector((state) => state.apps.items)
  const total = useAppSelector((state) => state.apps.total)
  const offset = useAppSelector((state) => state.apps.offset)
  const pageSize = useAppSelector((state) => state.apps.pageSize)
  const activeFilter = useAppSelector((state) => state.apps.activeFilter)
  const searching = useAppSelector((state) => state.apps.searching)

  const currentPage = Math.floor(offset / pageSize) + 1
  const totalPages = Math.max(1, Math.ceil(total / pageSize))

  const goToPage = (page: number) => {
    const newOffset = (page - 1) * pageSize
    dispatch(setOffset(newOffset))
    dispatch(fetchApps({ status: activeFilter, offset: newOffset, limit: pageSize }))
  }

  return (
    <div className="app-card-grid-wrapper">
      <div className="app-card-grid" data-testid="app-card-grid" aria-live="polite">
        {items.length === 0 ? (
          <div className="app-card-grid__empty" data-testid="app-card-grid-empty">
            No apps found for this filter.
          </div>
        ) : (
          items.map((app) => <AppCard key={app.id} app={app} />)
        )}
      </div>
      {!searching && totalPages > 1 && (
        <nav className="pagination" data-testid="pagination" aria-label="App list pagination">
          <button
            className="pagination__btn"
            data-testid="pagination-prev"
            disabled={currentPage <= 1}
            onClick={() => goToPage(currentPage - 1)}
          >
            Previous
          </button>
          <span className="pagination__info" data-testid="pagination-info">
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="pagination__btn"
            data-testid="pagination-next"
            disabled={currentPage >= totalPages}
            onClick={() => goToPage(currentPage + 1)}
          >
            Next
          </button>
        </nav>
      )}
    </div>
  )
}

export default AppCardGrid
